import formConfirm from "../class/formConfirm";

export default class customFormConfirm extends formConfirm {
  constructor(opt) {
    super(opt);
  }

  // 上書きするメソッドを記入
  
}